import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../contexts/UserContext";

/**
 * Komponent przekierowujący dla Daily Task Coordination
 * - Admin → Resource Board
 * - Coordinator → Daily Planning
 */
const DailyTaskCoordinationRedirect = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    const isAdmin = ['admin', 'adminves', 'superuser'].includes(user?.role);

    if (isAdmin) {
      navigate('/daily-task-coordination/resource-board', { replace: true });
    } else {
      // Coordinator
      navigate('/daily-task-coordination/daily-planning', { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    </div>
  );
};

export default DailyTaskCoordinationRedirect;
